/* eslint-disable no-unused-vars */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';

const BrowserReqComponent = () => {
  return (
    <div className="v1811_831">
      <div className="v1811_947" />
      <div className="v1811_989" />
      <div className="v1811_990" />
      <span className="v1811_991">Browser Requirements</span>
      <div className="row mt-2" />
      <div className="row mt-2" />
      <div className="row mt-5">
        Conduent recognizes that our visitors may have various operating systems
        and Internet browsers. While we want every visitor to have the best
        possible experience on our website, we recognize that it is imposible to
        develop applications that work identically with all browsers. Therefore,
        we have designed, developed and tested our applications to work
        correctly with the following browsers. If you would like to download the
        most current version please click on a link below.
      </div>
      <span className="v1811_997">Browser Compatibility Statement</span>
      <div className="row align-self-center mt-5">
        <div className="col-8 offset-2">
          <Card>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead style={{ background: '#274463' }}>
                  <TableRow>
                    <TableCell
                      style={{
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '14px',
                      }}
                    >
                      Browser
                    </TableCell>
                    <TableCell
                      style={{
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '14px',
                      }}
                    >
                      Version
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Link
                        to="https://www.google.com/chrome/"
                        target="_blank"
                        className="a site-map ml-2"
                        title="Chrome"
                        style={{ color: '#004A99' }}
                      >
                        Chrome
                      </Link>{' '}
                    </TableCell>
                    <TableCell>116.x and greater</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Link
                        to="https://www.microsoft.com/en-us/download/internet-explorer.aspx"
                        target="_blank"
                        className="a site-map ml-2"
                        title="Microsoft"
                        style={{ color: '#004A99' }}
                      >
                        Microsoft
                      </Link>{' '}
                    </TableCell>
                    <TableCell>116.x and greater</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Link
                        to="https://www.mozilla.org/en-US/firefox/releases/"
                        target="_blank"
                        className="a site-map ml-2"
                        title="Firefox"
                        style={{ color: '#004A99' }}
                      >
                        Firefox
                      </Link>{' '}
                    </TableCell>
                    <TableCell>118.x and greater</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </div>
      </div>
    </div>
  );
};
export default BrowserReqComponent;
